import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import DeleteAccount from './components/DeleteAccount';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            
            {/* Protected Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
            </Route>
            
            {/* Redirect to dashboard if authenticated, otherwise to login */}
            <Route 
              path="*" 
              element={
                <AuthRedirect />
              } 
            />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

// Helper component to handle redirects based on auth state
function AuthRedirect() {
  const { currentUser } = useAuth();
  return currentUser ? <Navigate to="/" replace /> : <Navigate to="/login" replace />;
}

export default App;
